function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconDownloadMediumOutline = function IconDownloadMediumOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.998 13.176l3.245-3.245a1 1 0 011.414 1.414L12 17.002l-5.657-5.657a1 1 0 111.414-1.414l3.241 3.24V3.976c0-.51.448-.925 1-.925s1 .414 1 .925v9.2zM6 19h12a1 1 0 110 2H6a1 1 0 110-2z",
    clipRule: "evenodd"
  }));
};

export default IconDownloadMediumOutline;